<template>
    <b-overlay>
        <div class="row">
            <div class="col-12">
                <b-form-checkbox-group stacked v-model="value.TransferRegionIds" value-field="Id" text-field="Name" :options="regions"/>
            </div>
        </div>
    </b-overlay>
</template>

<script>
import { BOverlay, BFormCheckboxGroup } from 'bootstrap-vue';
import { MaterialApi } from '@/api/material'

export default{
    props:{
        value:Object
    },
    components:{
        BOverlay,
        BFormCheckboxGroup
    },
    data(){
        return {
            regions:[],
            regionsGetting:false
        }
    },
    mounted(){
        this.getRegions()
    },
    methods:{
        getRegions(){
            this.regionsGetting = true
            MaterialApi.GetTransferRegions(this.value.MaterialId).then(res => {
                this.regions = res.data.Data?.TransferRegions || []
                this.value.TransferRegionIds = this.regions.filter(s => s.Exists).map(d => d.Id)
                this.regionsGetting = false
            })
        }
    }
}
</script>